/*=========================================================================================
  File Name: analyticsData.vue
  Description: Data shown by charts
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  // LINE CHART
  siteTraffic: {
    series: [
      {
        name: "Traffic Rate",
        data: [150, 200, 125, 225, 200, 250],
      },
    ],
    chartOptions: {
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },
      chart: {
        type: "line",
        dropShadow: {
          enabled: true,
          top: 5,
          left: 0,
          blur: 4,
          opacity: 0.1,
        },
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      stroke: {
        width: 5,
        curve: "smooth",
      },
      xaxis: {
        type: "numeric",
      },
      colors: ["#7367F0"],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          gradientToColors: ["#A9A2F6"],
          shadeIntensity: 1,
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100],
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 5,
        },
      },
      tooltip: {
        x: {
          show: false,
        },
      },
    },
  },
  activeUsers: {
    series: [
      {
        name: "Active Users",
        data: [750, 1000, 900, 1250, 1000, 1200, 1100],
      },
    ],
    chartOptions: {
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },
      chart: {
        type: "line",
        dropShadow: {
          enabled: true,
          top: 5,
          left: 0,
          blur: 4,
          opacity: 0.1,
        },
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      stroke: {
        width: 5,
        curve: "smooth",
      },
      xaxis: {
        type: "numeric",
      },
      colors: ["#28C76F"],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          gradientToColors: ["#55DD92"],
          shadeIntensity: 1,
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 75, 100, 100],
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 5,
        },
      },
      tooltip: {
        x: {
          show: false,
        },
      },
    },
  },
  newsletter: {
    series: [
      {
        name: "Newsletter",
        data: [365, 390, 365, 400, 375, 400],
      },
    ],
    chartOptions: {
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },
      chart: {
        type: "line",
        dropShadow: {
          enabled: true,
          top: 5,
          left: 0,
          blur: 4,
          opacity: 0.1,
        },
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      stroke: {
        width: 5,
        curve: "smooth",
      },
      xaxis: {
        type: "numeric",
      },
      colors: ["#FF9F43"],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          gradientToColors: ["#ffc085"],
          shadeIntensity: 1,
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 75, 100, 100],
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 5,
        },
      },
      tooltip: {
        x: {
          show: false,
        },
      },
    },
  },
  totalVendas: {
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0"],
      chart: {
        id: "total-vendas-chart",
      },
      xaxis: {
        type: "category",
        categories: [],
      },
    },
    series: [
      {
        name: "Total de Vendas",
        data: [],
      },
    ],
  },
  vendasConcluidas: {
    valorAtual: 0,
    valorAnterior: 0,
    series: [
      {
        name: "Mês Atual",
        data: [45000, 47000, 44800, 47500],
      },
      {
        name: "Mês Anterior",
        data: [46000, 48000, 45500, 46600],
      },
    ],
    chartOptions: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      stroke: {
        curve: "smooth",
        dashArray: [0, 8],
        width: [4, 2],
      },
      grid: {
        borderColor: "#e7e7e7",
      },
      legend: {
        show: false,
      },
      colors: ["#00bfed", "#28c76f"],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          inverseColors: false,
          gradientToColors: ["#28c76f", "#b8c2cc"],
          shadeIntensity: 1,
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100],
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 5,
        },
      },
      xaxis: {
        labels: {
          style: {
            cssClass: "text-grey fill-current",
          },
        },
        axisTicks: {
          show: false,
        },
        categories: ["01", "10", "20", "30"],
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        tickAmount: 5,
        labels: {
          style: {
            cssClass: "text-grey fill-current",
          },
          formatter: function (val) {
            return val > 999 ? (val / 1000).toFixed(1) + "k" : val;
          },
        },
      },
      tooltip: {
        x: {
          show: false,
        },
      },
    },
  },

  // LINE AREA CHART
  valorCreditado: {
    qtd: 0,
    series: [
      {
        name: "Cotações",
        data: [0],
      },
    ],
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2.5,
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 0.9,
          opacityFrom: 0.7,
          opacityTo: 0.5,
          stops: [0, 80, 100],
        },
      },
      xaxis: {
        type: "numeric",
        lines: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
      yaxis: [
        {
          y: 0,
          offsetX: 0,
          offsetY: 0,
          padding: {
            left: 0,
            right: 0,
          },
        },
      ],
      tooltip: {
        x: {
          show: false,
        },
      },
    },
  },
  valorCustoCompra: {
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      chart: {
        id: "vuechart-example",
      },
      xaxis: {
        type: "numeric",
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
      },
    },
    series: [
      {
        name: "series-1",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
      },
    ],
  },
  qtdUsuarios: {
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      chart: {
        id: "vuechart-example",
      },
      xaxis: {
        type: "numeric",
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
      },
    },
    series: [
      {
        name: "series-1",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
      },
    ],
  },
  valorAcumulado: {
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      chart: {
        id: "vuechart-example",
      },
      xaxis: {
        type: "numeric",
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
      },
    },
    series: [
      {
        name: "series-1",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
      },
    ],
  },
  encomendas: {
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      chart: {
        id: "vuechart-example",
      },
      xaxis: {
        type: "numeric",
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
      },
    },
    series: [
      {
        name: "series-1",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
        colors: [
          "#957923",
          "#cbaeee",
          "#782c5f",
          "#ab088d",
          "#957923",
          "#cbaeee",
          "#782c5f",
          "#ab088d",
        ],
      },
    ],
  },

  ticketMedioIncluido: {
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      chart: {
        id: "vuechart-example",
      },
      xaxis: {
        type: "numeric",
        categories: [],
      },
    },
    series: [
      {
        name: "Ticket Médio",
        data: [],
      },
    ],
  },

  ticketMedioCML: {
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      chart: {
        id: "vuechart-example",
      },
      xaxis: {
        type: "numeric",
        categories: [],
      },
    },
    series: [
      {
        name: "Ticket Médio CML",
        data: [],
      },
    ],
  },

  ticketMedioVME: {
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      chart: {
        id: "vuechart-example",
      },
      xaxis: {
        type: "numeric",
        categories: [],
      },
    },
    series: [
      {
        name: "Ticket Médio VME",
        data: [],
      },
    ],
  },
  churn: {
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      chart: {
        id: "churn-chart",
      },
      xaxis: {
        type: "category",
        categories: [],
      },
    },
    series: [
      {
        name: "Churn (%)",
        data: [],
      },
    ],
  },
  retention: {
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      chart: {
        id: "retention-chart",
      },
      xaxis: {
        type: "category",
        categories: [],
      },
    },
    series: [
      {
        name: "Retenção (%)",
        data: [],
      },
    ],
  },
  ltv: {
    qtd: 0,
    chartOptions: {
      colors: ["#28C76F"],
      chart: {
        id: "ltv-chart",
      },
      xaxis: {
        type: "category",
        categories: [],
      },
    },
    series: [
      {
        name: "LTV",
        data: [],
      },
    ],
  },
  taxaRecompra: {
    qtd: 0,
    chartOptions: {
      colors: ["#28C76F"],
      chart: {
        id: "taxa-recompra-chart",
      },
      xaxis: {
        type: "category",
        categories: [],
      },
    },
    series: [
      {
        name: "Taxa de Recompra (%)",
        data: [],
      },
    ],
  },
  tempoEntreCompras: {
    qtd: 2.64,
    chartOptions: {
      colors: ["#00CFE8"],
      chart: {
        id: "tempo-entre-compras-chart",
      },
      xaxis: {
        type: "category",
        categories: ["2025-06-01 até 2025-06-30"],
      },
    },
    series: [
      {
        name: "Horas entre compras",
        data: [2.64],
      },
    ],
  },
  saldoContasExemplo: {
    qtd: 0,
    chartOptions: {
      colors: ["#FF9F43"],
      chart: {
        id: "saldo-contas-exemplo-chart",
      },
      xaxis: {
        type: "category",
        categories: [],
      },
    },
    series: [
      {
        name: "Saldo Contas de Exemplo",
        data: [],
      },
    ],
  },

  totalReembolsado: {
    qtd: 0,
    chartOptions: {
      colors: ["#EA5455"],
      chart: {
        id: "total-reembolsado-chart",
      },
      xaxis: {
        type: "category",
        categories: [],
      },
    },
    series: [
      {
        name: "Total Reembolsado (Extornos)",
        data: [],
      },
    ],
  },

  freteGratis: {
    show: false,
    qtd: 0,
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      chart: {
        id: "vuechart-example",
      },
      xaxis: {
        type: "numeric",
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
      },
    },
    series: [
      {
        name: "series-1",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
        colors: [
          "#957923",
          "#cbaeee",
          "#782c5f",
          "#ab088d",
          "#957923",
          "#cbaeee",
          "#782c5f",
          "#ab088d",
        ],
      },
    ],
  },
  qtdCaixasAbertas: {
    qtd: 0,
    series: [
      {
        name: "Cotações",
        data: [],
      },
    ],
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2.5,
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 0.9,
          opacityFrom: 0.7,
          opacityTo: 0.5,
          stops: [0, 80, 100],
        },
      },
      xaxis: {
        type: "numeric",
        lines: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
      yaxis: [
        {
          y: 0,
          offsetX: 0,
          offsetY: 0,
          padding: {
            left: 0,
            right: 0,
          },
        },
      ],
      tooltip: {
        x: {
          show: false,
        },
      },
    },
  },
  valorEmAberto: {
    qtd: 0,
    series: [
      {
        name: "Vistorias",
        data: [],
      },
    ],
    chartOptions: {
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2.5,
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 0.9,
          opacityFrom: 0.7,
          opacityTo: 0.5,
          stops: [0, 80, 100],
        },
      },
      xaxis: {
        type: "numeric",
        lines: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
      yaxis: [
        {
          y: 0,
          offsetX: 0,
          offsetY: 0,
          padding: {
            left: 0,
            right: 0,
          },
        },
      ],
      tooltip: {
        x: {
          show: false,
        },
      },
    },
  },
  valorEmAbertura: {
    qtd: 0,
    series: [
      {
        name: "Cotações",
        data: [],
      },
    ],
    chartOptions: {
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2.5,
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 0.9,
          opacityFrom: 0.7,
          opacityTo: 0.5,
          stops: [0, 80, 100],
        },
      },
      xaxis: {
        type: "numeric",
        lines: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
      yaxis: [
        {
          y: 0,
          offsetX: 0,
          offsetY: 0,
          padding: {
            left: 0,
            right: 0,
          },
        },
      ],
      tooltip: {
        x: {
          show: false,
        },
      },
    },
  },
  // BAR CHART
  salesBar: {
    series: [
      {
        name: "",
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
      },
    ],
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },

      xaxis: {
        categories: [
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
        ],
      },
      yaxis: {
        title: {
          text: "Quantidade",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "" + val + " Vendas";
          },
        },
      },
    },
  },

  salesBar2: {
    series: [
      {
        name: "",
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
      },
    ],
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },

      xaxis: {
        categories: [
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
        ],
      },
      yaxis: {
        title: {
          text: "R$",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "R$" + val + " ";
          },
        },
      },
    },
  },

  cancelamentosBar: {
    series: [
      {
        name: "",
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
      },
    ],
    chartOptions: {
      colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },

      xaxis: {
        categories: [
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
        ],
      },
      yaxis: {
        title: {
          text: "Quantidade",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "" + val + " processos";
          },
        },
      },
    },
  },

  // RADIAL BAR
  goalOverviewRadialBar: {
    series: [83],
    chartOptions: {
      plotOptions: {
        radialBar: {
          size: 110,
          startAngle: -150,
          endAngle: 150,
          hollow: {
            size: "77%",
          },
          track: {
            background: "#bfc5cc",
            strokeWidth: "50%",
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              offsetY: 18,
              color: "#99a2ac",
              fontSize: "4rem",
            },
          },
        },
      },
      colors: ["#00db89"],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: ["#00b5b5"],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
      chart: {
        sparkline: {
          enabled: true,
        },
        dropShadow: {
          enabled: true,
          blur: 3,
          left: 1,
          top: 1,
          opacity: 0.1,
        },
      },
    },
  },
  supportTrackerRadialBar: {
    chartData: {
      totalTickets: 163,
      openTickets: 103,
      lastResponse: "1d",
    },
    series: [83],
    chartOptions: {
      plotOptions: {
        radialBar: {
          size: 150,
          offsetY: 15,
          startAngle: -150,
          endAngle: 150,
          hollow: {
            size: "65%",
          },
          track: {
            background: "#fff",
            strokeWidth: "100%",
          },
          dataLabels: {
            value: {
              offsetY: 30,
              color: "#99a2ac",
              fontSize: "2rem",
            },
          },
        },
      },
      colors: ["#EA5455"],
      fill: {
        type: "gradient",
        gradient: {
          // enabled: true,
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: ["#7367F0"],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        dashArray: 8,
      },
      chart: {
        sparkline: {},
      },
      labels: ["Completed Tickets"],
    },
  },
  // RADAR
  conversaoMensal: {
    series: [
      {
        name: "Total",
        data: [90, 50, 86, 40, 100, 20],
      },
      {
        name: "Vistorias",
        data: [70, 75, 70, 76, 20, 85],
      },
    ],
    chartOptions: {
      labels: [
        "Jan/2020",
        "Feb/2020",
        "Mar/2020",
        "Apr/2020",
        "May/2020",
        "Jun/2020",
      ],
      dataLabels: {
        style: {
          colors: [
            "#b9c3cd",
            "#b9c3cd",
            "#b9c3cd",
            "#b9c3cd",
            "#b9c3cd",
            "#b9c3cd",
          ],
        },
      },
      yaxis: {
        show: false,
      },
      grid: {
        show: false,
      },
      legend: {
        show: false,
      },
      chart: {
        dropShadow: {
          enabled: true,
          blur: 8,
          left: 1,
          top: 1,
          opacity: 0.2,
        },
        toolbar: {
          show: false,
        },
      },
      stroke: {
        width: 0,
      },
      colors: ["#9f8ed7", "#1edec5"],
      plotOptions: {
        radar: {
          polygons: {
            strokeColors: [
              "#e8e8e8",
              "transparent",
              "transparent",
              "transparent",
              "transparent",
              "transparent",
            ],
            connectorColors: "transparent",
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          gradientToColors: ["#8e9ad6", "#1fcadb"],
          shadeIntensity: 1,
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100],
        },
      },
      markers: {
        size: 0,
      },
    },
  },
  // SessionsByDevice
  sessionsByDeviceDonut: {
    analyticsData: [
      {
        device: "Dekstop",
        icon: "MonitorIcon",
        color: "primary",
        sessionsPercentgae: 58.6,
        comparedResultPercentage: 2,
      },
      {
        device: "Mobile",
        icon: "SmartphoneIcon",
        color: "warning",
        sessionsPercentgae: 34.9,
        comparedResultPercentage: 8,
      },
      {
        device: "Tablet",
        icon: "TabletIcon",
        color: "danger",
        sessionsPercentgae: 6.5,
        comparedResultPercentage: -5,
      },
    ],
    comparedResult: [2, -3, 8],
    series: [58.6, 34.9, 6.5],
    chartOptions: {
      labels: ["Desktop", "Mobile", "Tablet"],
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      chart: {
        offsetY: 30,
        type: "donut",
        toolbar: {
          show: false,
        },
      },
      stroke: {
        width: 0,
      },
      colors: ["#7961F9", "#FF9F43", "#EA5455"],
      fill: {
        type: "gradient",
        gradient: {
          gradientToColors: ["#9c8cfc", "#FFC085", "#f29292"],
        },
      },
    },
  },
  // Product Orders
  tiposPropostas: {
    analyticsData: [
      {
        orderType: "Adesão",
        counts: 0,
        color: "primary",
      },
      {
        orderType: "Inclusão",
        counts: 0,
        color: "warning",
      },
      {
        orderType: "Reativação",
        counts: 0,
        color: "danger",
      },
      {
        orderType: "Substituição",
        counts: 0,
        color: "success",
      },
    ],
    series: [0, 0, 0, 0],
    chartOptions: {
      labels: ["Adesão", "Inclusão", "Reativação", "Substituição"],
      plotOptions: {
        radialBar: {
          size: 165,
          offsetY: 30,
          hollow: {
            size: "20%",
          },
          track: {
            background: "#ebebeb",
            strokeWidth: "100%",
            margin: 15,
          },
          dataLabels: {
            show: true,
            name: {
              fontSize: "18px",
            },
            value: {
              fontSize: "16px",
              color: "#636a71",
              offsetY: 11,
            },
            total: {
              show: true,
              label: "Total",
              formatter: function () {
                return 0;
              },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 576,
          options: {
            plotOptions: {
              radialBar: {
                size: 150,
                hollow: {
                  size: "20%",
                },
                track: {
                  background: "#ebebeb",
                  strokeWidth: "100%",
                  margin: 15,
                },
              },
            },
          },
        },
      ],
      colors: ["#00bfed", "#FF9F43", "#EA5455", "#14c44e"],
      fill: {
        type: "gradient",
        gradient: {
          // enabled: true,
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0.5,
          gradientToColors: ["#9be8f1", "#FFC085", "#f29292", "#28c76f"],
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
      chart: {
        dropShadow: {
          enabled: true,
          blur: 3,
          left: 1,
          top: 1,
          opacity: 0.1,
        },
      },
    },
  },
  // Customers
  origem: {
    analyticsData: [
      {
        customerType: "Network",
        counts: 0,
        color: "primary",
      },
      {
        customerType: "Site",
        counts: 0,
        color: "warning",
      },
      {
        customerType: "Indicação",
        counts: 0,
        color: "danger",
      },
    ],
    series: [0, 0, 0],
    chartOptions: {
      labels: ["Network", "Site", "Indicação"],
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      chart: {
        type: "pie",
        offsetY: 30,
        dropShadow: {
          enabled: false,
          blur: 5,
          left: 1,
          top: 1,
          opacity: 0.2,
        },
        toolbar: {
          show: false,
        },
      },
      stroke: {
        width: 5,
      },
      colors: ["#7961F9", "#FF9F43", "#EA5455"],
      fill: {
        type: "gradient",
        gradient: {
          gradientToColors: ["#9c8cfc", "#FFC085", "#f29292"],
        },
      },
    },
  },
  // Sales monthly
  salesLine: {
    series: [
      {
        name: "Sales",
        data: [140, 180, 150, 205, 160, 295, 125, 255, 205, 305, 240, 295],
      },
    ],
    chartOptions: {
      chart: {
        toolbar: {
          show: false,
        },
        dropShadow: {
          enabled: true,
          top: 20,
          left: 2,
          blur: 6,
          opacity: 0.2,
        },
      },
      stroke: {
        curve: "smooth",
        width: 4,
      },
      grid: {
        borderColor: "#ebebeb",
      },
      legend: {
        show: false,
      },
      colors: ["#df87f2"],
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          inverseColors: false,
          gradientToColors: ["#7367F0"],
          shadeIntensity: 1,
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100],
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 5,
        },
      },
      xaxis: {
        labels: {
          style: {
            cssClass: "text-grey fill-current",
          },
        },
        axisTicks: {
          show: false,
        },
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "July",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        tickAmount: 5,
        labels: {
          style: {
            cssClass: "text-grey fill-current",
          },
          formatter: function (val) {
            return val > 999 ? (val / 1000).toFixed(1) + "k" : val;
          },
        },
      },
      tooltip: {
        x: {
          show: false,
        },
      },
    },
  },
  // ClientRetention Bar Chart
  clientRetentionBar: {
    series: [
      {
        name: "New Clients",
        data: [175, 125, 225, 175, 160, 189, 206, 134, 159, 216, 148, 123],
      },
      {
        name: "Retained Clients",
        data: [
          -144, -155, -141, -167, -122, -143, -158, -107, -126, -131, -140,
          -137,
        ],
      },
    ],
    chartOptions: {
      grid: {
        borderColor: "#ebebeb",
        padding: {
          left: 0,
          right: 0,
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      chart: {
        stacked: true,
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      colors: ["#7367F0", "#EA5455"],
      plotOptions: {
        bar: {
          columnWidth: "10%",
        },
      },
      xaxis: {
        labels: {
          style: {
            cssClass: "text-grey fill-current",
          },
        },
        axisTicks: {
          show: false,
        },
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        tickAmount: 5,
        labels: {
          style: {
            cssClass: "text-grey fill-current",
          },
        },
      },
      tooltip: {
        x: {
          show: false,
        },
      },
    },
  },
  // OTHER
  browserAnalytics: [
    {
      id: 1,
      name: "Google Chrome",
      ratio: 73,
      time: "Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)",
      comparedResult: "800",
    },
    {
      id: 3,
      name: "Opera",
      ratio: 8,
      time: "Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)",
      comparedResult: "-200",
    },
    {
      id: 2,
      name: "Firefox",
      ratio: 19,
      time: "Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)",
      comparedResult: "100",
    },
    {
      id: 4,
      name: "Internet Explorer",
      ratio: 27,
      time: "Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)",
      comparedResult: "-450",
    },
  ],
};
